export default {
	SET_ERROR_STATUS: '@@base/SET_ERROR_STATUS',
	SET_GEO_DATA: '@@base/SET_GEO_DATA',
	SHOW_SIGN_MODAL: '@@base/TOGGLE_SIGN_MODAL',
	EDIT: '@@base/EDIT'
}
